/* Nordic Weaving: ønskeseddel, datalag
   Ingen afhængigheder. Alt state i localStorage.
   Bygget 26/8-2026.

   DELELINK, format valgt 26/8-2026:
     ?l=handle:base36variantid,handle:base36variantid, ...

   Første udkast kodede KUN variant-ID'er for at holde linket kort. Det viste sig ubrugeligt:
   der findes ingen offentlig Shopify-endpoint, der oversætter et variant-ID til et produkt,
   så modtagerens browser kunne ikke slå noget op. Handlen skal med.

   Alternativerne var et variantindeks som temafil eller et Storefront API-token. Begge giver
   kortere links, men begge kan fejle TAVST: et forældet indeks taber varer, og et tilbagekaldt
   token dræber delingen uden besked. Med handle i linket findes produktet enten, eller også
   siger siden det højt. Intet at vedligeholde. Længden rammer kun sms, og på Messenger og
   WhatsApp vises et preview-kort, hvor længden er usynlig.
*/
(function (w, d) {
  'use strict';

  var KEY = 'nw_wishlist_v1';
  var MAX = 100;      // hård grænse, beskytter mod at localStorage løber fuld
  var ENC_W = 9;      // base36-tegn pr. variant-ID. 36^9 dækker Shopifys 14-cifrede ID'er
  var EVT = 'nw:wishlist:change';

  /* ---------- base36 ---------- */

  function enc36(n) {
    var s = Number(n).toString(36);
    while (s.length < ENC_W) s = '0' + s;
    return s;
  }

  function dec36(s) {
    var n = parseInt(s, 36);
    return isFinite(n) && n > 0 ? n : null;
  }

  /* ---------- lager ---------- */

  function read() {
    try {
      var raw = w.localStorage.getItem(KEY);
      if (!raw) return [];
      var o = JSON.parse(raw);
      return Array.isArray(o.i) ? o.i : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      w.localStorage.setItem(KEY, JSON.stringify({ v: 1, t: Date.now(), i: items.slice(0, MAX) }));
      return true;
    } catch (e) {
      // Privat browsing eller fyldt kvote. Listen lever videre i hukommelsen
      // indtil siden genindlæses, så brugeren kan nå at dele eller sende den.
      return false;
    }
  }

  function emit(action, item) {
    var items = read();
    try {
      d.dispatchEvent(new CustomEvent(EVT, {
        detail: { action: action, item: item || null, count: items.length, items: items }
      }));
    } catch (e) {}
  }

  /* ---------- opslag ---------- */

  function idx(items, vid) {
    vid = String(vid);
    for (var i = 0; i < items.length; i++) if (String(items[i].v) === vid) return i;
    return -1;
  }

  /* ---------- offentligt API ---------- */

  var API = {
    all: function () { return read(); },

    count: function () { return read().length; },

    has: function (vid) { return idx(read(), vid) > -1; },

    /* item: { v: variantId, h: handle, t: titel, p: pris i oere, img: url, s: variantnavn } */
    add: function (item) {
      if (!item || !item.v) return false;
      var items = read();
      if (idx(items, item.v) > -1) return false;
      items.unshift({
        v: String(item.v),
        h: item.h || '',
        t: item.t || '',
        p: item.p || null,
        img: item.img || '',
        s: item.s || '',
        ts: Date.now()
      });
      write(items);
      emit('add', item);
      return true;
    },

    remove: function (vid) {
      var items = read(), i = idx(items, vid);
      if (i < 0) return false;
      var removed = items.splice(i, 1)[0];
      write(items);
      emit('remove', removed);
      return true;
    },

    toggle: function (item) {
      return API.has(item.v) ? (API.remove(item.v), false) : (API.add(item), true);
    },

    /* Skifter variant PAA PLADSEN. Bruges naar stoerrelsen rettes paa oenskeseddel-siden.
       add() ville laegge varen oeverst og rykke rundt paa listen, mens man sidder og retter i den.
       Tidsstemplet beholdes, saa raekkefoelgen er den samme bagefter.
       Findes den nye variant allerede paa listen, fjernes den gamle i stedet for at lave en dublet. */
    swap: function (oldVid, item) {
      if (!item || !item.v) return false;
      var items = read(), i = idx(items, oldVid);
      if (i < 0) return false;
      if (String(item.v) !== String(oldVid) && idx(items, item.v) > -1) {
        return API.remove(oldVid);
      }
      items[i] = {
        v: String(item.v),
        h: item.h || items[i].h,
        t: item.t || items[i].t,
        p: (item.p === 0 || item.p) ? item.p : null,
        img: item.img || '',
        s: item.s || '',
        ts: items[i].ts || Date.now()
      };
      write(items);
      emit('swap', items[i]);
      return true;
    },

    /* Laegger en hel delt liste ind som brugerens egen. Springer varer over,
       der allerede ligger der, saa der ikke opstaar dubletter. */
    merge: function (list) {
      if (!list || !list.length) return 0;
      var items = read(), n = 0;
      list.forEach(function (x) {
        if (!x || !x.v || idx(items, x.v) > -1) return;
        items.push({
          v: String(x.v),
          h: x.h || '',
          t: x.t || '',
          p: (x.p === 0 || x.p) ? x.p : null,
          img: x.img || '',
          s: x.s || '',
          ts: Date.now()
        });
        n++;
      });
      if (n) { write(items); emit('merge'); }
      return n;
    },

    clear: function () {
      write([]);
      emit('clear');
      return true;
    },

    /* ---------- delelink ---------- */

    encode: function (items) {
      items = items || read();
      var out = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i], n = Number(it.v);
        if (!it.h || !isFinite(n) || n <= 0) continue;
        out.push(it.h + ':' + enc36(n));
      }
      return out.join(',');
    },

    /* Returnerer [{h: handle, v: variantId}]. Resten hentes friskt af siden. */
    decode: function (str) {
      if (!str || typeof str !== 'string') return [];
      var out = [], seen = {};
      str.split(',').forEach(function (part) {
        var bits = part.split(':');
        if (bits.length !== 2) return;
        var h = bits[0].replace(/[^a-z0-9-]/gi, '').toLowerCase();
        var v = dec36(bits[1]);
        if (!h || !v || seen[v]) return;
        seen[v] = 1;
        out.push({ h: h, v: String(v) });
      });
      return out.slice(0, MAX);
    },

    /* ':' og ',' er lovlige i en query-vaerdi, saa de kodes bevidst ikke.
       encodeURIComponent ville gøre linket 40% længere uden at vinde noget. */
    shareUrl: function (path) {
      var p = path || '/pages/oenskeseddel';
      var code = API.encode();
      return w.location.origin + p + (code ? '?l=' + code : '');
    },

    /* Læser ?l= fra URL'en. Bruges af ønskeseddel-siden til at vise en delt liste. */
    fromUrl: function () {
      var m = w.location.search.match(/[?&]l=([^&]*)/);
      if (!m) return [];
      var raw = m[1];
      try { raw = decodeURIComponent(raw); } catch (e) {}
      return API.decode(raw);
    },

    KEY: KEY,
    EVENT: EVT
  };

  w.NWWishlist = API;
  try { d.dispatchEvent(new CustomEvent('nw:wishlist:ready')); } catch (e) {}

})(window, document);